import $ from 'jquery'
import Flickity from 'flickity'

import jqueryBridget from 'jquery-bridget'

$.bridget( 'flickity', Flickity)

export default {

  enable () {
    $('.project-slider.enabled').flickity({
      wrapAround: true,
      groupCells: '100%',
      autoPlay: 4000,
      prevNextButtons: true,
      selectedAttraction: 0.015,
      friction: 0.5
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/project-slider.js